<div style="margin-top:10%;" class="waiting-panel">
  <div class="mx-auto loader mb-3" style="margin-bottom: 40px;"></div>
  <h2 class="text-center">Your browser is computing access.</h2>
  <h6 class="text-center">the process is automatic and you will be redirected to your requested content shortly</h6>
  <h6 class="text-center">(a commit a day keeps the mobs away)</h6>
</div>